<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">CHAPTER 1</h2>
<hr class="hr"/>
<h2 class="h2title">THE VERY EDGE OF THINGS</h2>
<p class="noindent"><span class="stickup">T</span>he first- and second-fastest kids in the second grade stood at the end of Rosedale Street in the early June heat, their bird chests heaving, asphalt fumes stinging their noses. They were so thin a mesh of blue veins showed under brown skin.</p>
<p class="indent">“It’s cuh-cuh-coming,” the smaller boy said, nodding toward the angry purple smudge on the horizon behind them. His skull was slightly elongated, somehow giving him a studious air.</p>
<p class="indent">“Couple minutes,” said the other, taller but just as brown and skinny, scrunching his bare toes into the sun-softened tar.</p>
<p class="indent">It would have been difficult for an adult to appreciate their boundless sense of possibilities as they stood waiting: the vastness of the coming summer, the endless expanse of school years ahead, the insignificance of their tiny lives when measured against any grown-up conception of time.</p>
<p class="indent">But for now they were simply oblivious to everything but the dark specter approaching Rosedale Street.</p>
<p class="indent">The sky darkened suddenly, and from nowhere a chilly wind began whipping through the Spanish moss in the live oaks across Bumby Avenue, raising goose bumps on their forearms. The boys leaned into a half crouch with hands on knees and waited.</p>
<p class="indent">The first fat drops splatted on the roadway, making little hissy puffs of steam, and as they began landing on the boys’ skin, a crack of thunder split the sky. They took off down the street in a blur of spindly legs and arms.</p>
<p class="indent">They were fairly evenly matched but were not really racing each other as much as simply trying to stay ahead of the deluge at their heels.</p>
<p class="indent">This moment always seemed magical to them: a bright tropical day loomed in front as a purple monsoon came on from behind. And they were thrilled as only children can be thrilled to exist for a moment at the very edge of things, at the buzzy existential margin of all possibilities. One might go fetch a Popsicle or be struck by lightning or live to a well-tended old age with golf clubs in the trunk. Whirl was king and all was in play.</p>
<p class="indent">All they knew was that for this moment in time they were racing the rain, and they were laughing laughing laughing.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?7e37b08c